import * as React from "react";
import { E2EIdentifier } from "../../../e2e/E2EIdentifier";
import { Wrapper } from "../Common";
import { AutoplaySettings } from "../Common/AutoplaySettings.view";
import { ResetButton } from "./components/AutoplayAdvanced/ResetButton";
import { Title } from "./components/AutoplayAdvanced/Title";

export const AutoplayAdvancedMobile = ({
  onChange,
  onReset,
  settings,
  disabled,
  resetButtonLabel,
  title,
  requiredText
}: any) => {
  if (!Array.isArray(settings) || !settings.length) {
    return null;
  }

  const isResetEnabled = settings?.some(x => x.active || x.attributes?.value);

  return (
    <Wrapper disabled={disabled}>
      {title && <Title>{title}</Title>}
      <AutoplaySettings
        settings={settings}
        onChange={onChange}
        disabled={disabled}
        requiredText={requiredText}
      />
      <ResetButton
        data-e2e-id={E2EIdentifier.AUTOPLAY_RESET_BUTTON}
        label={resetButtonLabel}
        onClick={onReset}
        disabled={!isResetEnabled}
      />
    </Wrapper>
  );
};
